export const ADD_SINDROME_ANALISIS = "ADD_SINDROME_ANALISIS";
export const DELETE_SINDROME_ANALISIS = "DELETE_SINDROME_ANALISIS";
